module.exports = __webpack_public_path__ + "680cee87d721c7255d9a962d340c69b8.jpg";